jQuery(document).ready(function($) {
    var input = $('input#background-switch');
    input.change(function() {
        var v = $(this).is(':checked') ? 1 : 0;
        setCookie('show_background_to_me', v);
        $('html').fadeOut(200, function() {
            if(v == 0) {
                $('body').addClass('no-bg');
            } else {
                $('body').removeClass('no-bg');
            }
            $('html').fadeIn(200);
        });
    });
    var showMeBackground = getCookie('show_background_to_me', 1);
    if(showMeBackground == 0) {
        input[0].checked = false;
        input.trigger('change');
    }
});